import CustomToggleSwitch from '@/Components/CustomToggleSwitch/CustomToggleSwitch';
import { Button } from '@/Components/UI/Button/Button';
import HelperText from '@/Components/UI/HelperText/HelperText';
import Tooltip from '@/Components/UI/Tooltip/Tooltip';

const ViewToggle = ({
  inputValue = '',
  selectedView,
  isSelectedViewEnabled = false,
  onCopyButtonClick,
  isToolTipVisible,
  onToggleButtonChange,
  isDisabled,
}) => {
  return (
    <div className='flex-col h-full p-4 cursor-default'>
      {selectedView ? (
        <div>
          <div className='flex justify-between'>
            <div>
              <span className='font-semibold'>{selectedView?.name || ''}</span>{' '}
              <span data-cy='link-status-text'>
                {isSelectedViewEnabled ? 'is enabled' : 'is not enabled'}
              </span>
            </div>
            <Tooltip text={isSelectedViewEnabled ? 'Disable URL' : 'Enable URL'} side='bottom'>
              <CustomToggleSwitch
                onChange={onToggleButtonChange}
                isChecked={isSelectedViewEnabled}
                switcher='SimpleSwitcher'
                wrapperClassName='!mr-0'
                cypressId='link-activation-toggle'
                isDisabled={isDisabled}
              />
            </Tooltip>
          </div>

          {isSelectedViewEnabled && (
            <>
              <div className='flex mt-4 mb-1'>
                <input
                  readOnly
                  value={inputValue}
                  type='text'
                  data-cy='input-liveshare-url'
                  className='w-full h-8 px-3 border rounded-l outline-none border-ui-200 focus:ring-1 focus:ring-midnight-100'
                />
                <div className='relative'>
                  <Button
                    iconName='copy'
                    color='oceanBlue'
                    className='!rounded-l-none'
                    onClick={onCopyButtonClick}
                    disabled={isToolTipVisible}
                  />
                  {isToolTipVisible && (
                    <span className='absolute p-2 text-xs text-white -translate-x-1/2 rounded w-fit bg-midnight-900 left-1/2 -bottom-full '>
                      copied!
                    </span>
                  )}
                </div>
              </div>
              <HelperText text='Anyone with this URL may be able to access the underlying data.' />
            </>
          )}
        </div>
      ) : (
        <div data-cy='select-a-view' className='flex items-center justify-center w-full h-full'>
          Select a View
        </div>
      )}
    </div>
  );
};
export default ViewToggle;
